var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('spoof-badge'),_c('layout-broker'),_c('div',[_c('portal-target',{attrs:{"name":"MODAL","multiple":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }